import fr from './translations/fr'
export default fr
